export default {
  gymClass: {},
  classSchedule: {},
  showDialog: false,
  showClassTimeDialog:false
}